/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serializer for children statistics (watched & touched skills, competencies, literacies).
 */
export interface ChildrenStats { 
    readonly fullName: string;
    readonly birthDate: string;
    profileImage?: string;
    readonly childUuid: string;
    readonly watchedSkillsCount: number;
    readonly watchedCompetenciesCount: number;
    readonly touchedSkillsCount: number;
    readonly touchedCompetenciesCount: number;
    readonly touchedLiteraciesCount: number;
    readonly touchedWatchSkillsCount: number;
    readonly touchedWatchCompetenciesCount: number;
    readonly isWatched: boolean;
    readonly firstLevelDone: boolean;
    readonly secondLevelDone: boolean;
    readonly thirdLevelDone: boolean;
}